module.exports = __webpack_public_path__ + "static/media/greenTick.5240fbb4.png";